module.exports = __webpack_public_path__ + "img/bed-pulse.e49932c5.svg";